import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule, DatePipe} from '@angular/common';

// Material Components
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatExpansionModule} from '@angular/material/expansion';
import {ClipboardModule} from '@angular/cdk/clipboard';

// Our Components
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {authInterceptorProviders} from './services/auth_intercepter.service';
import {errorInterceptorProviders} from './services/error_interceptor.service';
import {LoginComponent} from './components/login/login.component';
import {NavbarComponent} from './components/navbar/navbar.component';
import {HomeComponent} from './components/home/home.component';
import {UpsertEmployeeComponent} from './components/upsert_employee/upsert_employee.component';
import {MatNativeDateModule, MatOptionModule} from '@angular/material/core';
import {EmployeeComponent} from './components/employee/employee.component';
import {ApplicationComponent} from './components/application/application.component';
import {ReviewApplicationComponent} from './components/review_application/review_application.component';
import {AuthGuardService} from './services/auth_guard_service.service';
import {PhoneMaskDirective} from './utils/validators/phone_mask.directive';
import {ReviewServiceApplicationComponent} from './components/review_service_application/review_service_application.component';
import {ServiceApplicationComponent} from './components/service_application/service_application.component';
import {ServiceTypeTableComponent} from './components/service_type_table/service_type_table.component';
import {AdminSettingsComponent, EditSettingsDialog} from './components/admin_settings/admin_settings.component';
import {AdminErrorDialog} from './components/error_dialog/error_dialog.component';
import {ContractTemplateComponent} from './components/contract_template/contract_template.component';
import {DeleteTemplateDialog} from './components/contract_template/dialogs/delete_template_dialog.component';
import {ProviderTableComponent} from './components/provider_table/provider_table.component';
import {CustomerTableComponent} from './components/customer-table/customer_table.component';
import {ACHRecordDialogComponent} from './components/customer-table/ach_record_dialog/ach_record_dialog.component';
import {ProviderDataDialogComponent} from './components/provider_table/provider_data_dialog/provider_data_dialog.component';
import {CustomerApplicationDialogComponent} from './components/customer-table/customer_application_dialog/customer_application_dialog.component';
import { CustomerContractDialogComponent } from './components/customer-table/customer_contract_dialog/customer_contract_dialog.component';
import { ContractComponent } from './components/contract/contract.component';
import { AchRecordsComponent } from './components/ach-records/ach-records.component';
import { CustomerDetailsComponentComponent } from './components/ach-records/details-dialog/customer-details-component/customer-details-component.component';
import { ProviderBillingComponent } from './components/provider-billing/provider-billing.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { InvoiceDialogComponent } from './components/provider-billing/invoice-dialog/invoice-dialog.component';
import { UpdateInvoiceDialogComponent } from './components/provider-billing/update-invoice-dialog/update-invoice-dialog.component';
import { QuestionnaireReviewComponent } from './components/questionnaire-review/questionnaire-review.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';

@NgModule({
    declarations: [AppComponent],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        MatButtonModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatInputModule,
        MatIconModule,
        MatListModule,
        MatOptionModule,
        MatSelectModule,
        MatSidenavModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTableModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatMenuModule,
        ClipboardModule,
        MatCardModule,
        MatTabsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        LoginComponent,
        NavbarComponent,
        HomeComponent,
        UpsertEmployeeComponent,
        EmployeeComponent,
        ApplicationComponent,
        ReviewApplicationComponent,
        ServiceApplicationComponent,
        ReviewServiceApplicationComponent,
        ServiceTypeTableComponent,
        PhoneMaskDirective,
        AdminSettingsComponent,
        AdminErrorDialog,
        EditSettingsDialog,
        ContractTemplateComponent,
        DeleteTemplateDialog,
        ProviderTableComponent,
        CustomerTableComponent,
        ACHRecordDialogComponent,
        ProviderDataDialogComponent,
        CustomerApplicationDialogComponent,
        CustomerContractDialogComponent,
        ContractComponent,
        AchRecordsComponent,
        CustomerDetailsComponentComponent,
        ProviderBillingComponent,
        InvoiceDialogComponent,
        UpdateInvoiceDialogComponent,
        QuestionnaireReviewComponent,
    ],
    exports: [
        PhoneMaskDirective,
    ],
    providers: [
        authInterceptorProviders,
        errorInterceptorProviders,
        [AuthGuardService],
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
